export default __webpack_public_path__ + "static/media/INDIAS2.87712a10.png";